<template>
  <v-card elevation="3" class="rounded-lg" flat @click="detailLog(log)">
    <v-card-text>
      <v-row>
        <v-col cols="8">
          <div class="font-weight-bold">{{ getSubject(log.subject) }}</div>
          <span class="sample--date">
            {{ getFormatted(log.date) }}
          </span>
        </v-col>
        <v-col cols="1" class="d-flex align-center">
          <v-img
            max-width="27"
            max-height="27"
            :src="require('@/assets/img/book.svg')"
          ></v-img>
        </v-col>
        <v-col cols="3" class="d-flex justify-center">
          <span
            class="secondary--text font-weight-bold text-end"
            style="align-self: center"
          >
            {{ log.photographicEvidence.length }}
          </span>
          <v-icon color="#b3b3b3" size="28" right>mdi-camera</v-icon>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";

import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    subject: [
      "Otro",
      "Problema detectado",
      "Aplicación de producto",
      "Aplicación de producto SOLENA",
      "Desarrollo Vegetativo",
    ],
    subject_en: [
      "Other",
      "Problem detected",
      "Product application",
      "SOLENA product application",
      "Vegetative development",
    ],
  }),
  props: {
    log: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapMutations("logs", ["SET_LOG_SELECTED"]),
    detailLog(log) {
      this.SET_LOG_SELECTED(log);
      this.$router.push(`/detail-log/${log._id}`);
    },
    getSubject(sub) {
      let i = 0;
      let subT = "";
      for (let subject of this.subject_en) {
        if (sub == subject) {
          subT = this.subject[i];
          i = 0;
          break;
        }
        i++;
      }
      return subT;
    },
    getFormatted(date) {
      return moment.utc(date).format("YYYY-MM-DD");
    },
  },
  created() {},
};
</script>

<style scoped>
.sample--date {
  font-size: 0.9rem;
  color: #818181;
}
</style>
